import { faViber, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import {
  faCopy,
  faEnvelope,
  faShareAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import UpdatingPopover from "../UpdatingPopover";

const Share = ({
  onShareViaMail,
  onShareViaViber,
  onShareViaWhatsapp,
  onCopyUrl,
  size
}) => {
  return (
    <>
      <OverlayTrigger
        trigger="click"
        placement="top"
        opacity="1"
        rootClose
        overlay={
          <UpdatingPopover id="share_buttons">
            <Popover.Content>
              <Button
                className="buttonStyle"
                onClick={onShareViaMail}
                size={size}
                title={labels.shareWithMail}
              >
                <FontAwesomeIcon icon={faEnvelope} />
              </Button>
              <Button
                className="buttonStyle whatsAppColor"
                onClick={onShareViaWhatsapp}
                size={size}
                title={labels.shareWithWhatsApp}
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </Button>
              <Button
                className="buttonStyle viberColor"
                onClick={onShareViaViber}
                size={size}
                title={labels.shareWithViber}
              >
                <FontAwesomeIcon icon={faViber} />
              </Button>
              <Button
                className="buttonStyle"
                onClick={onCopyUrl}
                size={size}
                variant="secondary"
                title={labels.copyLink}
              >
                <FontAwesomeIcon icon={faCopy} />
              </Button>
            </Popover.Content>
          </UpdatingPopover>
        }
      >
        <Button className="buttonStyle" size={size}>
          <FontAwesomeIcon icon={faShareAlt} />
        </Button>
      </OverlayTrigger>
    </>
  );
};

export default Share;
